import LocationMask from "../LocationMask";
import { pxChangeVw } from "@/utils";
import classNames from "classnames";

export const useCptUtil = ({
  mergedHeaderStyle,
  containerRef,
  isRtl,
  updateChildState,
  isShowLocationIcon,
  maskNode,
  animateRef,
  headerData,
  imgStyle,
}: any) => {
  /**
   * 渲染通用天气信息列表（重复代码抽离）
   */
  const renderWeatherList = () => (
    <ul className="inline-block flex items-center">
      {/* 第1列 */}
      <li className="inline-block mr-8 align-top w-30 relative">
        <WeatherImage
          className="img mt-0! absolute top-50% left-50% translate-[-50%]"
          src={headerData?.WeatherIconImg}
          style={imgStyle}
        />
      </li>
      {/* 第2列 */}
      {headerData?.WeatherText && <li className="inline-block mr-8 align-top ">{headerData.WeatherText}</li>}
      {/* 第3列 */}
      {(headerData?.Temperature?.Value || headerData?.Temperature?.Unit) && (
        <li className="inline-block mr-8 align-top ">
          {headerData?.Temperature?.Value}
          {/* {headerData?.Temperature?.Unit} */}℃
        </li>
      )}
      {/* 第4列 */}
      {(headerData?.Wind?.Direction?.Localized ||
        headerData?.Wind?.Speed?.Metric?.Value ||
        headerData?.Wind?.Speed?.Metric?.Unit) && (
        <li className="inline-block mr-8 align-top ">
          {headerData?.Wind?.Direction?.Localized} {headerData?.Wind?.Speed?.Metric?.Value}{" "}
          {headerData?.Wind?.Speed?.Metric?.Unit}
        </li>
      )}
      {/* 第5列 */}
      {headerData?.Wind?.Metric?.Value && (
        <li className="inline-block align-top mr-0">
          {headerData.Wind.Metric.Value} {headerData?.Wind?.Metric?.Unit}
        </li>
      )}
    </ul>
  );

  /**
   * 渲染通用位置模块（重复代码抽离）
   */
  const renderLocation = () => (
    <div
      className="flex justify-start items-center"
      style={{ width: isRtl ? "auto" : "60vw", overflow: isRtl ? "visible" : "hidden" }}
      onClick={updateChildState}
    >
      <div className={classNames(["w-full flex items-center p-[2px_0]"])}>
        {isShowLocationIcon && (
          <div
            className="flex-[0] box-border flex items-center"
            style={{
              paddingLeft: isRtl ? pxChangeVw("10px") : "0px",
              paddingRight: isRtl ? "0px" : pxChangeVw("10px"),
            }}
          >
            {renderIconFont("icon-weizhi1", {
              color: "var(--app-text-04)",
              fontSize: "16px",
            })}
          </div>
        )}

        <div className="flex-[1] overflow-hidden flex items-center">
          <LocationMask ref={maskNode} />
        </div>
      </div>
    </div>
  );

  /**
   * 渲染通用右侧天气信息模块（重复代码抽离）
   */
  const renderWeather = () => (
    <div
      className={classNames(["whitespace-nowrap overflow-hidden text-13 flex justify-start items-center"])}
      style={{
        width: isRtl ? "auto" : "40vw",
        height: "50px",
      }}
    >
      <div className={classNames(["inline-block whitespace-nowrap px-4 py-0 font-[Roboto_Light]"])} ref={animateRef}>
        {renderWeatherList()}
      </div>
    </div>
  );

  /**
   * 主体组件渲染（逻辑/样式/结构完全保持原样）
   */
  const getCpt01 = () => {
    // 默认通用结构
    return (
      <div className="box-border w-full  p-[0_10px] app-top-bar" style={mergedHeaderStyle} ref={containerRef}>
        <div className="flex justify-between items-center gap-x-24">
          {/* 地理位置 */}
          {renderLocation()}
          {/* 天气信息 */}
          {renderWeather()}
        </div>
      </div>
    );
  };

  return {
    getCpt01,
  };
};
